var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavoriteTransparent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeWidth: 1.5,
  d: "M10.958 15.969c-.394.27-.722.488-.956.641a46.694 46.694 0 0 1-4.022-2.936c-1.138-.93-2.286-1.98-3.204-3.046-.93-1.08-1.564-2.112-1.765-3.006l-.009-.036-.011-.036A4.7 4.7 0 0 1 .75 6.07c0-1.81 1.016-3.392 2.53-4.219a4.96 4.96 0 0 1 2.368-.601A4.93 4.93 0 0 1 9.428 3l.575.681.573-.682A4.92 4.92 0 0 1 14.35 1.25c.86 0 1.667.22 2.37.601 1.515.828 2.53 2.41 2.53 4.22 0 .516-.086 1.013-.242 1.48l-.011.035-.009.036c-.202.894-.835 1.925-1.765 3.006-.917 1.067-2.066 2.116-3.202 3.046a47 47 0 0 1-3.063 2.295Z"
})));
export default SvgFavoriteTransparent;